/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import $ from 'jquery';
import logger from 'js-sdk/src/common/logging/logger';
import dashboardSettings from '../dashboardSettings';
import {loadDynamicModule} from 'bi-report/src/bi/report/loader/dynamicModuleLoader';
import defaultLinkHandlers from './defaultLinkHandlersEnum';

const log = logger.register("defaultLinkOptions");

const handlers = {
    ...defaultLinkHandlers
}

function onHandlerLoaded(type, handlerDeferreds, hyperlinkHandler) {
    handlers[type] = hyperlinkHandler;
    handlerDeferreds[type].resolve();
}

function onLoadFailed(type, err) {
    var moduleId = err.requireModules && err.requireModules[0];
    if (moduleId) {
        log.error('Failed to load module: \'' + moduleId + '\' for handling hyperlinks of type: \'' + type + '\'!');
    }
}

export default {
    events: function () {
        var obj = {}, events = dashboardSettings.DEFAULT_HYPERLINK_EVENTS;
        for (var i = 0; i < events.length; i++) {
            obj[events[i]] = function (ev, link, dashlet) {
                // convert fusion charts click to normal event type
                var eventName = ev.eventType === 'jr_hyperlink_interception' ? 'click' : ev.type.toLowerCase(),
                    type = link.type, handler = handlers[type];
                if (handler && handler.events && typeof handler.events[eventName] === 'function') {
                    return handler.events[eventName].apply(this, arguments);
                }
            };
        }
        return obj;
    }(),
    beforeRender: function (linkToElemPairs, dashlet) {
        //PRE-load hyperlink handlers
        var pairsByType = {}, self = this;    //get unique list of link types
        //get unique list of link types
        _.each(linkToElemPairs, function (pair) {
            if (!pairsByType[pair.data.type]) {
                pairsByType[pair.data.type] = [];
            }
            pairsByType[pair.data.type].push(pair);
        });    //load modules to handle these types
        //load modules to handle these types
        _.each(_.keys(pairsByType), function (type) {
            if (handlers[type] && handlers[type].beforeRender) {
                handlers[type].beforeRender.apply(self, arguments);
            }
        });
    },
    discoverHyperlinkHandlers: function (linkToElemPairs) {
        const dfd = new $.Deferred();
        const handlerDeferreds = {};
        const requiredHyperlinkTypes = _.chain(linkToElemPairs).map(function (obj) {
            return obj.data ? obj.data.type : undefined;
        }).unique().value();

        _.each(requiredHyperlinkTypes, function (type) {
            if (!handlers[type]) {
                handlerDeferreds[type] = new $.Deferred();
                type && loadDynamicModule(dashboardSettings.HYPERLINK_MODULE_PREFIX + type)
                    .then(_.partial(onHandlerLoaded, type, handlerDeferreds))
                    .catch(_.partial(onLoadFailed, type));
            }
        });
        $.when.apply($, _.values(handlerDeferreds)).always(function () {
            dfd.resolve();
        });
        return dfd;
    }
};